<rt-box layout-horizontal layout-full-width margin-bottom>
  <div>
    @if (requester) {
      <rt-avatar
        [type]="requester.hasAvatar ? 'image' : 'initials'"
        [initials]="requester.initials"
        [imageSrc]="requester.photoThumbUrl"
        context="admin"
      />
    }
    @if (!requester) {
      <rt-avatar type="icon" iconName="person" size="base" />
    }
  </div>
  <div layout-full-width padding-left-small>
    <div layout layout-space-between>
      <rt-heading>
        {{ requesterFullName }}
        {{ 'app.requisitions.details_page.approval_message_box.heading' | translate }}
      </rt-heading>
      <div layout>
        @if (attachments.length) {
          <rt-icon
            [rtTooltip]="
              'app.requisitions.details_page.approval_message_box.attachments_tooltip' | translate
            "
            name="attach-file"
          />
        }
        <rt-date margin-left-small [time]="createdAt()" />
      </div>
    </div>
    <div
      class="request-message-container"
      [style.max-height]="
        messageCollapsed && hasExpandButton ? COLLAPSED_MESSAGE_MAX_HEIGHT + 'px' : 'initial'
      "
      margin-top-small-x
    >
      <div #requestMessageText [innerHtml]="bodyHtml()"></div>
      @if (attachments.length) {
        <div class="attachments-container">
          @for (attachment of attachments; track trackById($index, attachment)) {
            <rt-attachment-item [attachment]="attachment" type="tile" />
          }
        </div>
      }
    </div>
    @if (hasExpandButton) {
      <div layout margin-top-small>
        <rt-button variant="plain" (click)="toggleShowMore()">
          <rt-icon [name]="messageCollapsed ? 'keyboard-arrow-down' : 'keyboard-arrow-up'" />
          <span>
            {{ (messageCollapsed ? 'app.common.show_more' : 'app.common.show_less') | translate }}
          </span>
        </rt-button>
      </div>
    }
  </div>
</rt-box>
